import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.2 6.6V1.8L5.4 4.27 1.2 6.6zM8.4 3.6h14.4v1.2H8.4zM1.2 11.4h21.6v1.2H1.2zM1.2 19.2h21.6v1.2H1.2z" /></svg>;